module.exports = __webpack_public_path__ + "img/handwritten-postcard@2x.0d96f41b.jpg";